// import React from "react";
// import classNames from "../../classNames";

// const defaultProps = {
//   className: "bg-white",
//   icon: "bi bi-people",
//   value: "0",
//   label: "TOTAL",
//   labelAction: "VIEW",
// };

// function DashboardCard({
//   className,
//   icon,
//   label,
//   value,
//   labelAction,
//   onClick,
//   percentage,
//   bg,
// }) {
//   const [count, setCount] = React.useState(0);

//   React.useEffect(() => {
//     const start = count;
//     const end = parseInt(value);
//     const duration = 1000;
//     const range = end - start;
//     const increment = Math.ceil(Math.abs(range) / (duration / 10));

//     let current = start;
//     const timer = setInterval(() => {
//       current += range > 0 ? increment : -increment;
//       if ((range > 0 && current >= end) || (range < 0 && current <= end)) {
//         setCount(end);
//         clearInterval(timer);
//       } else {
//         setCount(current);
//       }
//     }, 10);

//     return () => clearInterval(timer);
//   }, [value]);

//   return (
//     <div
//       className={classNames("shadow-sm p-3 p-lg-4 rounded")}
//       style={{ backgroundColor: bg }}
//     >
//       <div className="d-flex justify-content-between">
//         <span className="fs-2">
//           <i className={icon} style={{ color: "#83c14a" }}></i>
//         </span>
//         <h3 style={{ color: "#83c14a" }}>{count.toLocaleString()}</h3>
//       </div>
//       <div className="text-end">
//         <p className="m-0 text-truncate">{label}</p>
//       </div>

//       <div
//         className="text-end"
//         style={{ color: percentage < 100 ? "red" : "#83c14a" }}
//       >
//         <p className="m-0 text-truncate">
//           {" "}
//           {percentage < 100 ? (
//             <i className="bi bi-chevron-double-down"></i>
//           ) : (
//             <i class="bi bi-chevron-double-up"></i>
//           )}{" "}
//           {percentage}%
//         </p>
//       </div>

//       <hr />
//       {/* {labelAction === "VIEW" && (
//         <button
//           onClick={onClick}
//           className="btn btn-link p-0 w-100 d-flex justify-content-between text-uppercase text-truncate"
//         >
//           {labelAction}
//           <i className="bi bi-arrow-right"></i>
//         </button>
//       )} */}
//     </div>
//   );
// }

// DashboardCard.defaultProps = defaultProps;
// export default DashboardCard;
import React from "react";
import classNames from "../../classNames";

const defaultProps = {
  className: "bg-white",
  icon: "bi bi-people",
  value: "0",
  label: "TOTAL",
  labelAction: "VIEW",
};

function DashboardCard({
  className,
  icon,
  label,
  value,
  labelAction,
  onClick,
  percentage,
  bg,
}) {
  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    const start = count;
    const end = parseInt(value);
    const duration = 1000;
    const range = end - start;
    const increment = Math.ceil(Math.abs(range) / (duration / 10));

    let current = start;
    const timer = setInterval(() => {
      current += range > 0 ? increment : -increment;
      if ((range > 0 && current >= end) || (range < 0 && current <= end)) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(current);
      }
    }, 10);

    return () => clearInterval(timer);
  }, [value]);

  const isPositive = percentage >= 100;

  return (
    <div
      style={{
        background: bg || "rgba(255, 255, 255, 0.7)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        borderRadius: "16px",
        padding: "20px",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        boxShadow: "0 4px 20px 0 rgba(31, 38, 135, 0.12)",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.4s ease",
        cursor: onClick ? "pointer" : "default",
      }}
      // onClick={onClick}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow =
            "0 8px 28px 0 rgba(131, 193, 74, 0.2)";
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow =
            "0 4px 20px 0 rgba(31, 38, 135, 0.12)";
        }
      }}
    >
      {/* Gradient Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "120px",
          height: "120px",
          background:
            "linear-gradient(135deg, rgba(131, 193, 74, 0.08), transparent)",
          borderRadius: "50%",
          transform: "translate(40%, -40%)",
          pointerEvents: "none",
        }}
      />

      {/* Content */}
      <div style={{ position: "relative", zIndex: 1 }}>
        {/* Header Row */}
        <div className="d-flex align-items-center justify-content-between mb-3">
          {/* Icon with Pulse Animation */}
          <div
            style={{
              width: "44px",
              height: "44px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #83c14a, #6fad3e)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 3px 12px rgba(131, 193, 74, 0.35)",
              position: "relative",
            }}
          >
            {/* Pulse Ring */}
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                borderRadius: "12px",
                background: "rgba(131, 193, 74, 0.3)",
                animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
              }}
            />
            <i
              className={icon}
              style={{
                fontSize: "20px",
                color: "#ffffff",
                position: "relative",
                zIndex: 1,
              }}
            ></i>
          </div>

          {/* Percentage Badge */}
          {percentage !== undefined && (
            <div
              style={{
                padding: "4px 10px",
                borderRadius: "10px",
                background: isPositive
                  ? "linear-gradient(135deg, #10b981, #059669)"
                  : "linear-gradient(135deg, #ef4444, #dc2626)",
                color: "#ffffff",
                fontSize: "11px",
                fontWeight: "700",
                display: "flex",
                alignItems: "center",
                gap: "3px",
                boxShadow: isPositive
                  ? "0 3px 10px rgba(16, 185, 129, 0.25)"
                  : "0 3px 10px rgba(239, 68, 68, 0.25)",
              }}
            >
              <i
                className={isPositive ? "bi bi-arrow-up" : "bi bi-arrow-down"}
                style={{ fontSize: "10px" }}
              ></i>
              {Math.abs(percentage - 100).toFixed(1)}%
            </div>
          )}
        </div>

        {/* Value */}
        <h2
          className="m-0 mb-1"
          style={{
            fontSize: "32px",
            fontWeight: "800",
            background: "linear-gradient(135deg, #1e293b, #475569)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            lineHeight: "1",
            letterSpacing: "-0.8px",
          }}
        >
          {count.toLocaleString()}
        </h2>

        {/* Label */}
        <p
          className="m-0"
          style={{
            fontSize: "11px",
            fontWeight: "600",
            color: "#64748b",
            textTransform: "uppercase",
            letterSpacing: "0.8px",
          }}
        >
          {label}
        </p>
      </div>

      {/* CSS Animation */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 0.3;
          }
          50% {
            transform: scale(1.15);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
}

DashboardCard.defaultProps = defaultProps;
export default DashboardCard;
